var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg"},[_c('img',{attrs:{"src":require("../../img/download.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"link"},[_c('router-link',{staticClass:"android",attrs:{"to":"/"}}),_vm._v(" "),_c('router-link',{staticClass:"iphone",attrs:{"to":"/"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce94889","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/index.vue
// module id = null
// module chunks = 